import { useCallback } from 'react';

import { useAppSelector } from 'features/app/hooks';
import { callIdSelector } from 'features/call/call-base/store/selectors';
import type { CallCommentsFormValues } from 'features/call/call-comments/interfaces';
import { CommentDaoService } from 'features/call/call-comments/services';
import type { CreateCommentRequest } from 'features/call/call-survey/interfaces';
import { selectPreviousCallBeingReportedId } from 'features/call/vrs-call-comments/store';
import { userSelector } from 'features/user/store';

export const useCreateCallComments = () => {
  const user = useAppSelector(userSelector);
  const callIdOfPreviousReportedCall = useAppSelector(
    selectPreviousCallBeingReportedId
  );
  const callId = useAppSelector(callIdSelector);

  const createComment = useCallback(
    ({ commentTypes, commentText }: CallCommentsFormValues) => {
      const payload: CreateCommentRequest = {
        callId: callId || callIdOfPreviousReportedCall,
        userId: user.id,
        commentBy: `${user.firstName} ${user.lastName} Interpreter`,
        commentTypes,
        commentText,
      };

      return CommentDaoService.createComment(payload);
    },
    [callId, callIdOfPreviousReportedCall, user]
  );

  return { createComment };
};
